const YANDEX_MAPS_API_URL = "https://api-maps.yandex.ru/2.1/"

function buildScriptUrl(apiKey) {
  const url = new URL(YANDEX_MAPS_API_URL)
  url.searchParams.set("lang", "ru_RU")
  url.searchParams.set("coordorder", "latlong")
  if (apiKey) url.searchParams.set("apikey", apiKey)
  return url.toString()
}

export function loadYandexMaps(apiKey) {
  if (window.__yandexMapsApiPromise) return window.__yandexMapsApiPromise
  if (window.ymaps) return Promise.resolve(window.ymaps)

  window.__yandexMapsApiPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = buildScriptUrl(apiKey)
    script.async = true

    script.onload = () => {
      if (window.ymaps) {
        window.ymaps.ready(() => resolve(window.ymaps))
      } else {
        reject(new Error("ymaps не загрузился"))
      }
    }

    script.onerror = () => reject(new Error("Не удалось загрузить Яндекс.Карты"))
    document.head.appendChild(script)
  })

  return window.__yandexMapsApiPromise
}

export function allBoundaryPoints(geoJson) {
  if (!geoJson || typeof geoJson !== "object") return []

  if (geoJson.type === "Polygon") {
    return geoJson.coordinates.flat()
  }
  if (geoJson.type === "MultiPolygon") {
    return geoJson.coordinates.flat(2)
  }
  return []
}

export function geoJsonToYandexPolygonCoords(geoJson) {
  if (!geoJson || typeof geoJson !== "object") return []

  if (geoJson.type === "Polygon") {
    return geoJson.coordinates.map((ring) => ring.map(([ lng, lat ]) => [ lat, lng ]))
  }
  if (geoJson.type === "MultiPolygon") {
    return geoJson.coordinates.flatMap((polygon) =>
      polygon.map((ring) => ring.map(([ lng, lat ]) => [ lat, lng ]))
    )
  }
  return []
}

export function boundaryBbox(geoJson) {
  const points = allBoundaryPoints(geoJson)
  if (points.length === 0) return null

  const lats = points.map((p) => p[1])
  const lngs = points.map((p) => p[0])
  return [ [ Math.min(...lats), Math.min(...lngs) ], [ Math.max(...lats), Math.max(...lngs) ] ]
}

export function boundaryCenter(geoJson) {
  const bbox = boundaryBbox(geoJson)
  if (!bbox) return null

  return [ (bbox[0][0] + bbox[1][0]) / 2, (bbox[0][1] + bbox[1][1]) / 2 ]
}

export function createDistrictPolygon(geoJson) {
  const coordinates = geoJsonToYandexPolygonCoords(geoJson)
  if (coordinates.length === 0) return null

  return new ymaps.Polygon(coordinates, {}, {
    strokeColor: "#2563EB",
    strokeWidth: 2,
    fillColor: "rgba(37, 99, 235, 0.05)",
    interactivityModel: "default#transparent",
    zIndex: 1
  })
}
